<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">积分消耗记录</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
            <el-form-item label="用户手机号">
                <el-input size="small" v-model="formInline.phone" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <!-- <el-form-item label="申请时间">
                <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item> -->
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="id" label="用户id" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="status" label="昵称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="amount" label="手机号" ></el-table-column>
            <el-table-column  prop="commission" label="消耗积分数"></el-table-column>
            <el-table-column  prop="createdAt" label="消耗原因" ></el-table-column>
            <el-table-column  prop="storeName" label="消耗时间" ></el-table-column>
            <el-table-column align="center" label="操作"> 
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadRecoverOrderList  } from '../../../api/userMG'
export default {
    data(){
        return{
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        handleEdit(row){
            this.detailsFlag = true

        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadRecoverOrderList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                id:this.formInline.name,
                phone:this.formInline.phone
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/shoppingMall/integral/IntegralConsumption.vue